module.exports = __webpack_public_path__ + "static/media/ic-column-add.bace7260.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/table-icons/ic-column-add.svg
// module id = 819
// module chunks = 17